import { useInterviewOptions } from '@providers/InterviewsProvider';
import { AccessRole } from '@synergetx/puppet-interview-types';
import { useDatabaseUser } from '@components/FirebaseAuthentication';

export default function useIsGroupAdmin(): boolean {
    const { selectedInterview } = useInterviewOptions();
    const databaseUser = useDatabaseUser();
    return (
        databaseUser?.availableInterviews?.find(
            (interview) => interview.groupId === selectedInterview?.groupId,
        )?.role === AccessRole.ADMIN
    );
}
